<mat-card style="min-height: 700px">
  <ng-container *ngIf="{ data: data$ | async } as view">
    <app-card-header title="Edit Protocol" [subtitle]="view.data ? view.data.irbNumber + ': ' + view.data.studyTitle : ''" [ngClass]="routeAnimationsElements"></app-card-header>
    <div *ngIf="(loading || !formReady) && !loadError && !formError" fxLayout="row" fxLayoutAlign="center" class="mt-5">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
    <div *ngIf="loadError || formError" role="alert" class="p-3">
      <p>{{ loadError || formError }}</p>
      <button mat-stroked-button color="accent" (click)="retry()">Retry</button>
      <button mat-stroked-button (click)="cancel()">Back</button>
    </div>
    <ng-container *ngIf="view.data as data">
    <mat-card-content class="p-3" [ngClass]="routeAnimationsElements">
      <form [formGroup]="form" *ngIf="formReady">
        <input type="hidden" formControlName="irbNumber" />
        <input type="hidden" formControlName="previousIrbNumber" />
        <!-- Previous IRB Number -->
        <div *ngIf="data.previousIrbNumber" class="mb-2">
          <span class="mat-h4">Previous IRB Number: </span><span>{{ data.previousIrbNumber }}</span>
        </div>
        <div class="form-section mat-elevation-z4">Protocol Details</div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Study Title</mat-label>
              <input matInput formControlName="studyTitle" required />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>IRBNet Number</mat-label>
              <input matInput formControlName="irbNetNumber" maxlength="250">
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Protocol Status</mat-label>
              <mat-select formControlName="protocolStatusId">
                <mat-option *ngFor="let option of statusOptions$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Funding Agency</mat-label>
              <mat-select formControlName="fundingAgencyId">
                <mat-option *ngFor="let option of fundingAgency$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Nature of Research</mat-label>
              <mat-select formControlName="natureOfResearchId">
                <mat-option *ngFor="let option of natureOfResearch$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Type of Research</mat-label>
              <mat-select formControlName="typeOfResearchId">
                <mat-option *ngFor="let option of researchTypeOptions$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4 col-sm-12" *ngIf="form.get('typeOfResearchId')?.value === sponsoredResearchTypeId">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Type of Sponsored Clinical Trial (Drug/Device/Biologic)</mat-label>
              <mat-select formControlName="sponsoredClinicalTrialId">
                <mat-option *ngFor="let option of sponsoredClinicalTrial$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- Ownership -->
        <div class="form-section mat-elevation-z4">Ownership</div>
        <div class="row">
          <!-- Principal Investigator Autocomplete -->
          <div class="col-md-12 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Principal Investigator</mat-label>
              <input type="text" matInput formControlName="investigatorSearch" [matAutocomplete]="piAuto"
                placeholder="Type to search...">
              <mat-autocomplete #piAuto="matAutocomplete" [displayWith]="displayResearcher"
                (optionSelected)="onPrincipalInvestigatorSelected($event.option.value)">
                <mat-option *ngFor="let researcher of filteredPrincipalInvestigators$ | async" [value]="researcher">
                  {{ formatResearcher(researcher) }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="form.get('principalInvestigatorId')?.hasError('required')">
                Principal Investigator is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <!-- NTRIRB Coordinator Autocomplete -->
          <div class="col-md-12 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>NTRIRB Coordinator</mat-label>
              <input type="text" matInput formControlName="ntrIrbCoordinatorSearch" [matAutocomplete]="coordinatorAuto"
                placeholder="Type to search...">
              <button *ngIf="form.get('ntrIrbCoordinatorSearch')?.value" mat-icon-button matSuffix type="button"
                aria-label="Clear" (click)="clearNtrIrbCoordinator()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #coordinatorAuto="matAutocomplete" [displayWith]="displayResearcher"
                (optionSelected)="onNtrirbCoordinatorSelected($event.option.value)">
                <mat-option *ngFor="let researcher of filteredNtrirbCoordinators$ | async" [value]="researcher">
                  {{ formatResearcher(researcher) }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Department</mat-label>
              <mat-select formControlName="departmentId">
                <mat-option *ngFor="let option of departmentOptions$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>School</mat-label>
              <mat-select formControlName="schoolId">
                <mat-option *ngFor="let option of schoolOptions$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Institution</mat-label>
              <mat-select formControlName="institutionId">
                <mat-option *ngFor="let option of institutionOptions$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Collaborating Institution</mat-label>
              <mat-select formControlName="collaboratingInstitutionId">
                <mat-option *ngFor="let option of collaboratingInstitutionOptions$ | async" [value]="option.id">{{
                  option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Co-Investigator</mat-label>
              <input readonly matInput formControlName="coInvestigator" maxlength="250">
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>CR Coordinator</mat-label>
              <input readonly matInput formControlName="crCoordinator" maxlength="250">
            </mat-form-field>
          </div>
        </div>
        <!-- Sponsorship -->
        <div class="form-section mat-elevation-z4">Sponsorship</div>
        <div formArrayName="sponsorTypeCategories">
          <div class="row mb-2" *ngFor="let group of sponsorTypeCategoriesForm.controls; let i = index"
            [formGroupName]="i">
            <div class="col-md-3 col-sm-12">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Sponsor Type</mat-label>
                <mat-select formControlName="categoryId" (selectionChange)="onSponsorTypeChange(i)">
                  <mat-option *ngFor="let type of sponsorTypeOptions$ | async" [value]="type.id">{{ type.name
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-3 col-sm-12">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Sponsor</mat-label>
                <mat-select formControlName="subCategoryId"
                  [disabled]="!sponsorTypeCategoriesForm.at(i).get('categoryId')?.value">
                  <mat-option *ngFor="let sponsor of filteredSponsors[i] || []" [value]="sponsor.id">{{ sponsor.name
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-4 col-sm-12">
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>Sponsor Protocol</mat-label>
                <input matInput formControlName="sponsorProtocol" maxlength="250">
              </mat-form-field>
            </div>
            <div class="col-md-2 d-flex align-items-center">
              <button *ngIf="i != 0" mat-icon-button color="warn" (click)="removeSponsorTypeCategory(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <button mat-stroked-button color="primary" (click)="addSponsorTypeCategory()">Add Sponsor</button>

        <div class="form-section mat-elevation-z4">Review</div>

        <div class="row">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Type of Review</mat-label>
              <mat-select formControlName="typeOfReviewId">
                <mat-option *ngFor="let option of reviewTypeOptions$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Review Cycle</mat-label>
              <mat-select formControlName="reviewCycleId">
                <mat-option *ngFor="let option of reviewCycleOptions$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row"
          *ngIf="form.get('typeOfReviewId')?.value && cededReviewTypeId !== undefined && form.get('typeOfReviewId')?.value === cededReviewTypeId">
          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>IRB of Record</mat-label>
              <mat-select formControlName="irbofRecordId">
                <mat-option *ngFor="let option of irbofRecord$ | async" [value]="option.id">{{ option.name
                  }}</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('irbofRecordId')?.hasError('required')">
                IRB of Record is required when Type of Review is Ceded.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <!-- Special Findings -->
        <div class="form-section mat-elevation-z4">Special Findings</div>

        <div class="row">
          <div class="col-sm-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Special Findings Category</mat-label>
              <mat-select formControlName="specialFindingCategories" multiple>
                <mat-option *ngFor="let option of specialFindingOptions$ | async" [value]="option.id">
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Special Findings Notes</mat-label>
              <textarea matInput formControlName="specialFindings" rows="5"></textarea>
            </mat-form-field>
          </div>
        </div>
        <!-- Milestones Dates Section -->
        <div class="form-section mat-elevation-z4">Milestones</div>
        <div class="mt-3 mb-3">
          <span>All dates must occur after the initial submission date.</span>
        </div>
        <div class="row">
          <div class="col-md-3" *ngFor="let dateField of dateFields">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>{{ dateField.label }}</mat-label>
              <input matInput [matDatepicker]="picker" [formControlName]="dateField.controlName" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <!-- Research Personnel Section -->
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header class="custom-header">
              Research Personnel
            </mat-expansion-panel-header>
            <div class="mt-3 mb-4">
              <button mat-stroked-button color="primary" (click)="addPersonnel()">Add New Personnel</button>
            </div>
            <div formArrayName="personnelList">
              <div *ngFor="let person of personnelArrayForm.controls; let i = index" [formGroupName]="i">
                <div class="research-panel mat-elevation-z4">Personnel {{ i + 1 }}
                  <button mat-icon-button color="warn" (click)="removePersonnel(i)">
                    <mat-icon style="margin-right: 10px;">delete</mat-icon>
                  </button>
                </div>
                <div class="flex-row">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Research Personnel</mat-label>
                    <input #typehead type="text" placeholder="Search by Name, Email or Phone" aria-label="search"
                      matInput formControlName="researcherId" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayResearcher.bind(this)">
                      <mat-option *ngFor="let researcher of searchResearcher[i]" [value]="researcher">
                        {{ formatResearcher(researcher) }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="flex-row">
                  <mat-form-field appearance="fill">
                    <mat-label>Roles</mat-label>
                    <mat-select formControlName="rolesId" multiple>
                      <mat-option *ngFor="let option of availableRoles$ | async" [value]="option.id">
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>Institution</mat-label>
                    <mat-select formControlName="institutionId">
                      <mat-option *ngFor="let option of personnelInstitutionOptions$ | async" [value]="option.id">
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="flex-row">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="startDate" formControlName="startDate"
                      (dateChange)="onDateChange(i)">
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                    <mat-error *ngIf="form.get('startDate')?.hasError('required')">
                      Start Date is required
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="endDate" formControlName="endDate" (dateChange)="onDateChange(i)">
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                    <mat-error *ngIf="person.get('endDate')?.hasError('dateRange')">
                      End Date must be after Start Date
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </mat-card-content>
    <mat-card-actions align="end"  *ngIf="formReady">
      <button mat-stroked-button color="warn" (click)="cancel()">Back</button>
      <button *ngIf="isAdmin$ | async" mat-stroked-button color="accent" [disabled]="form.invalid || form.pristine"
        (click)="save()">
        Update
      </button>
    </mat-card-actions>
      </ng-container>
    </ng-container>
  </mat-card>

<!-- Protocol History -->
<mat-card class="mt-3" *ngIf="formReady">
  <ng-container *ngIf="data$ | async as data">
    <app-card-header title="Protocol History" subtitle="Change History"
      [ngClass]="routeAnimationsElements"></app-card-header>
    <mat-card-content class="p-3" [ngClass]="routeAnimationsElements">
      <app-protocol-history [history$]="data$"></app-protocol-history>
    </mat-card-content>
  </ng-container>
</mat-card>
